import { date } from "yup";
import { convertNumberToWords } from "../../../utilis/common-funtions";

import {
  CorporatePaymentMode,
  CorporateFinanceStatus,
} from "../../../config/constant";
export const NewPaymentbuildPayload = (
  multiFormikValues,
  saveForLater,
  bookinAs,
  amountInWords,
  lastStep,
  oppId
) => {
  const { transactions } = multiFormikValues;

  // Map transactions into required format
  const formattedTransactions = transactions
    .map((tx) => {
      if (tx.paymentMethod === CorporatePaymentMode.OFFLINE) {
        return {
          id: tx.id,
          paymentMode: CorporatePaymentMode.OFFLINE,
          paidAmount: Number(tx.amount),
          paymentProof: tx.paymentProof || [],
          isPhysicalPaymentProof: tx.isPhysicalPaymentProof || false,
          status:
            tx?.status === CorporateFinanceStatus.REJECTED
              ? CorporateFinanceStatus.UNVERIFIED
              : tx?.status || CorporateFinanceStatus.UNVERIFIED,
          paymentDate: tx.date,
          paymentDetails: {
            method: tx.offlineRadioOptions,
            chequeNumber:
              tx.offlineRadioOptions === "CHEQUE"
                ? tx.transactionNo
                : undefined,
            transactionNumber:
              tx.offlineRadioOptions !== "CHEQUE"
                ? tx.transactionNo
                : undefined,
            drawnOn: tx.bankName,
            // branchName: tx.branchName,
            // accountNumber: tx.accountNo,
          },
        };
      }
      return null;
    })
    .filter(Boolean);
  function CalculateSum() {
    const sum = transactions?.reduce(
      (acc, txn) => acc + (Number(txn.amount) || 0),
      0
    );
    return sum ;
  }
  const sum = CalculateSum();

  // Recovery Account details (from paymentOptionsFormik)

  // Final payload
  return {
    opportunityId:oppId,
    saveForLater,
    amount: Number(sum),
    payments: formattedTransactions,
    bookingAs: bookinAs,
    amountInWords: convertNumberToWords(sum),
    lastStep: lastStep,

  };
};

export const setFormValuesFromApplicantData = (
  applicantData,
  payments,
  multipaymentFormik,
  paymentFormik,
) => {
  if (!applicantData) return;

  // ---- Map Transactions ----
  const mappedTransactions = (payments || []).map((tx) => {
    const method = tx?.paymentDetails?.method || "";

    return {
      id: tx?.id,
      paymentMethod:
        tx?.paymentMode === CorporatePaymentMode.GATEWAY
          ? CorporatePaymentMode.GATEWAY
          : CorporatePaymentMode.OFFLINE,
      offlineRadioOptions: method,
      transactionNo:
        method === "CHEQUE"
          ? tx?.paymentDetails?.chequeNumber ||
            tx?.paymentDetails?.transactionNumber ||
            ""
          : tx?.paymentDetails?.transactionNumber || "",
      bankName: tx?.paymentDetails?.drawnOn || tx?.paymentDetails?.bank || "",
      // branchName: tx?.paymentDetails?.branchName || "",
      // accountNo: tx?.paymentDetails?.accountNumber || "",
      amount: tx?.paidAmount || "",
      paymentProof: tx?.paymentDetails?.paymentProof || [],
      status: tx?.status || CorporateFinanceStatus.UNVERIFIED,
      date: tx?.paymentDate || "",
      type: "",
      isPaid: [
        CorporateFinanceStatus.VERIFIED,
        CorporateFinanceStatus.REVERSED,
      ]?.includes(tx?.status)
        ? true
        : false,
      showUploadPopup: false,
      isPhysicalPaymentProof:
        tx?.paymentDetails?.isPhysicalPaymentProof || false,
      email: tx?.paymentDetails?.email || "",
      onlineMethod: tx?.paymentDetails?.method || "",
      contact: tx?.paymentDetails?.contact || "",
      orderId: tx?.paymentDetails?.order_id || "",
      gatewayPaymentId: tx?.paymentDetails?.gatewayPaymentId || "",
      paymentTransactionId: tx?.paymentDetails?.paymentTransactionId || "",
    };
  });

  multipaymentFormik.setValues({
    transactions:
      mappedTransactions.length > 0
        ? mappedTransactions
        : multipaymentFormik.initialValues.transactions,
  });

  // ---- Map Recovery Account ----

};

export function formatDateIST(isoDate) {
  if (!isoDate) return "-";

  const date = new Date(isoDate);

  // Convert to IST (UTC + 5:30)
  const istOffset = 5 * 60 + 30; // minutes
  const istTime = new Date(date.getTime() + istOffset * 60 * 1000);

  const day = String(istTime.getUTCDate()).padStart(2, "0");
  const month = istTime.toLocaleString("en-GB", {
    month: "short",
    timeZone: "UTC",
  });
  const year = istTime.getUTCFullYear();

  let hours = istTime.getUTCHours();
  const ampm = hours >= 12 ? "pm" : "am";
  hours = hours % 12 || 12;

  return `${day}-${month}-${year}`;
}

export function formatIndianNumber(num) {
  if (num === null || num === undefined || isNaN(num)) {
    return "0";
  }
  return Number(num).toLocaleString("en-IN");
}
